"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Pagination.css");
var icons_1 = require("@tiendanube/icons");
var __1 = require("..");
var model_1 = require("./model");
function Pagination(_a) {
    var pageTotal = _a.pageTotal, pageSelected = _a.pageSelected, _b = _a.hasMorePages, hasMorePages = _b === void 0 ? true : _b, _c = _a.margin, margin = _c === void 0 ? 1 : _c, _d = _a.padding, padding = _d === void 0 ? 2 : _d, onPageSelect = _a.onPageSelect;
    var handleClick = React.useCallback(function (event, page) {
        event.stopPropagation();
        onPageSelect(page);
    }, [onPageSelect]);
    var pages = React.useMemo(function () { return (pageTotal ? (0, model_1.getPages)(pageTotal, pageSelected, margin, padding) : []); }, [margin, padding, pageSelected, pageTotal]);
    return (React.createElement("nav", { role: "navigation", "aria-label": "Pagination", className: "nimbus--button-group" },
        React.createElement(__1.Button, { onClick: function (e) { return handleClick(e, pageSelected - 1); }, disabled: pageSelected === 1, icon: icons_1.ChevronLeftIcon, iconPosition: "start", appearance: "transparent" }),
        pages.map(function (page, index) {
            var label;
            var disabled;
            if (page.type === "NUMBER") {
                label = page.number;
                disabled = false;
            }
            else {
                label = "...";
                disabled = true;
            }
            return (React.createElement(__1.Button, { key: index, onClick: function (e) {
                    handleClick(e, page.number);
                }, appearance: page.selected ? "primary" : "transparent", disabled: disabled }, label));
        }),
        React.createElement(__1.Button, { onClick: function (e) {
                handleClick(e, pageSelected + 1);
            }, disabled: pageSelected === pageTotal || (!pageTotal && !hasMorePages), icon: icons_1.ChevronRightIcon, iconPosition: "end", appearance: "transparent" })));
}
exports.default = Pagination;
//# sourceMappingURL=index.js.map